import * as Sentry from '@sentry/vue'
import store from '@/store/index'
import ability from '@/plugins/acl/ability'

const MESSAGE = 'ACL: redirect to not-authorized'

function userAbilityMeta() {
  try {
    const raw = localStorage.getItem('userAbility')
    if (!raw) return { userAbilityRuleCount: 0, userAbilityBytes: 0 }
    const parsed = JSON.parse(raw)
    const userAbilityRuleCount = Array.isArray(parsed) ? parsed.length : -2
    return { userAbilityRuleCount, userAbilityBytes: raw.length }
  } catch {
    return { userAbilityRuleCount: -1, userAbilityBytes: localStorage.getItem('userAbility')?.length ?? 0 }
  }
}

/**
 * Single Sentry event for all client-side paths that send the user to misc-not-authorized.
 *
 * @param {Object} payload
 * @param {'router-guard'|'job-view'|'candidate-view'} payload.from
 * @param {import('vue-router').Route} [payload.to] — pass from router guard only
 * @param {boolean} [payload.isLoggedIn] — router guard only
 * @param {Record<string, unknown>} [payload.extra] — optional caller context (ids, flags)
 */
export function reportNotAuthorizedRedirect({ from, to, isLoggedIn, extra = {} }) {
  if (!Sentry.getCurrentHub().getClient()) return

  const host = typeof window !== 'undefined' ? window.location.host : ''
  const { recruiter } = store.state.recruiter
  const abilityMeta = userAbilityMeta()

  const recruiterState = {
    id: recruiter.id ?? null,
    access: recruiter.access ?? null,
  }

  const baseExtra = {
    from,
    ...abilityMeta,
    ...extra,
  }

  if (from === 'router-guard' && to) {
    const routesAcl = to.matched.map((route) => ({
      name: route.name,
      resource: route.meta?.resource,
      action: route.meta?.action || 'read',
      can: route.meta?.resource != null ? ability.can(route.meta.action || 'read', route.meta.resource) : null,
    }))

    Sentry.captureMessage(MESSAGE, {
      level: 'warning',
      fingerprint: ['acl-not-authorized', from, host, String(to.name || to.path)],
      tags: { host, from, targetRoute: String(to.name || to.path) },
      contexts: {
        recruiterState,
        navigation: {
          fullPath: to.fullPath,
          name: to.name,
          matchedCount: to.matched.length,
        },
      },
      extra: {
        ...baseExtra,
        isLoggedIn,
        routesAcl,
      },
    })
    return
  }

  Sentry.captureMessage(MESSAGE, {
    level: 'warning',
    fingerprint: ['acl-not-authorized', from, host],
    tags: { host, from },
    contexts: { recruiterState },
    extra: baseExtra,
  })
}
